import { types } from 'mobx-state-tree';

import { QUOTE_STATUSES } from '../definitions/InsCommon';


// Ideally this would use the Quote model from ins-common
//  but Auto currently uses it as well and we can't make 
//  modifications without also updating Auto's document
const Quote = types
    .model('Quote', {
        id: types.identifier,

        quoteId: types.string,
        brokerId: types.maybeNull(types.string),
        insurerId: types.string,

        yearlyRate: types.number,
        monthlyRate: types.number,
        termInMonths: types.number,

        // To be deprecated, this status shouldn't be stored in the model
        //  but just temporary in the FE. Will remove in V9 once we move
        //  quotes out of the Modelstore.
        status: types.optional(
            types.enumeration(Object.values(QUOTE_STATUSES)),
            QUOTE_STATUSES.READY,
        ),

        // extraData is required because the BE uses
        //  this to store additional information
        //  that is used by an inquiry event
        extraData: types.map(
            types.maybeNull(
                types.union(
                    types.string,
                    types.number,
                ),
            ),
        ),

        fulfillmentUrl: types.maybeNull(types.string),
    })
    .views(self => ({
        get hasFulfillmentUrl() {
            return !!self.fulfillmentUrl;
        },
    }))
    .actions(self => ({
        setFulfillmentUrl(url) {
            self.fulfillmentUrl = url;
        },
        setStatus(status) {
            self.status = status;
        },
    }));

export default Quote;
